import { CommonModule } from '@angular/common';
import {
  ChangeDetectionStrategy,
  Component,
  inject,
  OnInit,
} from '@angular/core';
import { Router, RouterModule } from '@angular/router';
import { TranslateModule, TranslateService } from '@ngx-translate/core';
import { ConfirmationService, MessageService } from 'primeng/api';
import { ButtonModule } from 'primeng/button';
import { CardModule } from 'primeng/card';
import { ConfirmDialogModule } from 'primeng/confirmdialog';
import { TableModule } from 'primeng/table';
import { TagModule } from 'primeng/tag';
import { ToastModule } from 'primeng/toast';
import { OpeningHourType } from '../../../shared/models/catalog/opening-hour-type.model';
import { OpeningHourTypeService } from '../../../shared/services/catalog/opening-hour-type.service';

@Component({
  selector: 'app-opening-hour-types-page',
  standalone: true,
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [
    CommonModule,
    RouterModule,
    TranslateModule,
    CardModule,
    TableModule,
    ButtonModule,
    TagModule,
    ToastModule,
    ConfirmDialogModule,
  ],
  providers: [MessageService, ConfirmationService],
  templateUrl: './opening-hour-types-page.component.html',
  styleUrl: './opening-hour-types-page.component.scss',
})
export class OpeningHourTypesPageComponent implements OnInit {
  service = inject(OpeningHourTypeService);
  #messageService = inject(MessageService);
  #confirmationService = inject(ConfirmationService);
  #translate = inject(TranslateService);
  #router = inject(Router);

  ngOnInit(): void {
    this.service.getAll();
  }

  navigateToCreate() {
    this.#router.navigate(['/catalog/opening-hour-types/new']);
  }

  navigateToDetail(item: OpeningHourType) {
    this.#router.navigate(['/catalog/opening-hour-types', item.id]);
  }

  hourCount(item: OpeningHourType): number {
    return Array.isArray(item.opening_hours) ? item.opening_hours.length : 0;
  }

  onRowDelete(event: Event, item: OpeningHourType) {
    this.#confirmationService.confirm({
      target: event.target as EventTarget,
      header: this.#translate.instant(
        'catalog.openingHourTypes.deleteConfirmHeader',
      ),
      message: this.#translate.instant(
        'catalog.openingHourTypes.deleteConfirmMessage',
      ),
      acceptLabel: this.#translate.instant('label.delete'),
      rejectLabel: this.#translate.instant('label.cancel'),
      acceptButtonProps: { severity: 'danger' },
      accept: () => {
        this.service.delete(item.id).subscribe({
          next: () => {
            this.service.getAll();
            this.#messageService.add({
              severity: 'success',
              summary: this.#translate.instant('label.successHeader'),
              detail: this.#translate.instant(
                'catalog.openingHourTypes.deleted',
              ),
            });
          },
          error: () => {
            this.#messageService.add({
              severity: 'error',
              summary: this.#translate.instant('label.errorHeader'),
              detail: this.#translate.instant(
                'catalog.openingHourTypes.deleteError',
              ),
            });
          },
        });
      },
    });
  }
}
